import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { graphql, useLazyLoadQuery } from 'react-relay/hooks'
import { usePage } from 'hooks'
import CompaniesTable from './CompaniesTable'
import OrganizationDashboard from '../../dashboards/OrganizationDashboard'
import { FlexColumn } from 'elements'

export default function CompaniesContainer() {
  const params = useParams()
  const slug = params.orgSlug || ''
  const { setHeader, setPageProps } = usePage()

  const data = useLazyLoadQuery(
    graphql`
      query CompaniesContainerQuery($slug: String!) {
        organizationBySlug(slug: $slug) {
          name
          id
          totalCompanies: companies(includeDeleted: NO) {
            totalCount
          }
          ...CompaniesTable_organization
          ...OrganizationDashboard_organization
        }
      }
    `,
    { slug },
  )

  const organization = data?.organizationBySlug

  useEffect(() => {
    if (organization) {
      setHeader({
        crumbs: [{ label: 'Clients', value: 'clients' }],
      })
      setPageProps({
        activeCompanyCount: organization?.totalCompanies.totalCount,
      })
    }
  }, [setHeader, setPageProps, organization])

  return (
    <FlexColumn>
      <OrganizationDashboard organization={organization} />
      <CompaniesTable organization={organization} />
    </FlexColumn>
  )
}
